var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoLined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.625C3.39453 0.625 0.5 3.54492 0.5 7.125C0.5 10.7305 3.39453 13.625 7 13.625C10.5801 13.625 13.5 10.7305 13.5 7.125C13.5 3.54492 10.5801 0.625 7 0.625ZM7 12.8125C3.85156 12.8125 1.3125 10.2734 1.3125 7.125C1.3125 4.00195 3.85156 1.4375 7 1.4375C10.123 1.4375 12.6875 4.00195 12.6875 7.125C12.6875 10.2734 10.123 12.8125 7 12.8125ZM7 5.29688C7.33008 5.29688 7.60938 5.04297 7.60938 4.6875C7.60938 4.35742 7.33008 4.07812 7 4.07812C6.64453 4.07812 6.39062 4.35742 6.39062 4.6875C6.39062 5.04297 6.64453 5.29688 7 5.29688ZM8.21875 9.5625H7.40625V6.71875C7.40625 6.51562 7.20312 6.3125 7 6.3125H6.1875C5.95898 6.3125 5.78125 6.51562 5.78125 6.71875C5.78125 6.94727 5.95898 7.125 6.1875 7.125H6.59375V9.5625H5.78125C5.55273 9.5625 5.375 9.76562 5.375 9.96875C5.375 10.1973 5.55273 10.375 5.78125 10.375H8.21875C8.42188 10.375 8.625 10.1973 8.625 9.96875C8.625 9.76562 8.42188 9.5625 8.21875 9.5625Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoLined);
export default __webpack_public_path__ + "static/media/info-lined.564a3fa6.svg";
export { ForwardRef as ReactComponent };